import React, { Component } from "react";


export default class FamilyStats extends Component {
    render() {
        return (
            <div>
                <h1>Family Statistics</h1>
            </div>

        )
    }
}